<template>
  <div>
    <h2 class="text-h2">Pet details page</h2>
    <div class="flex flex-row-reverse mt-48">
      <RouteStepperNextButton ref="routeStepperNextButton" :stepData="reviewSection" :draftData="draftData" />
    </div>
  </div>
</template>

<script lang="ts">
import RouteStepperNextButton from '@/components/route_stepper/RouteStepperNextButton.vue';
import { ReviewSection } from '@/components/route_stepper/types';
import { JobPostDraft } from './types';

export default {
  name: 'JobPostPetDetails',
  components: { RouteStepperNextButton },
  props: {
    draft: {
      type: Object,
      required: true,
    },
  },
  computed: {
    reviewSection(): ReviewSection | any {
      return {};
    },
    draftData(): JobPostDraft {
      return {};
    },
  },
};
</script>
